import { ChangeEvent, PageWidgetActionType } from '@nx-frontend/shared/types';
import { PORTAL_CHANGES_HISTORY_STORAGE_KEY } from '@nx-frontend/shared/types';
import { GtagEventParams } from './analytics';

declare global {
  interface Window {
    gtag?: (event: string, action: string, params: GtagEventParams) => void;
    userpilot: {
      trigger: (action: string) => void;
      track: (action: string) => void;
      on: <T = unknown>(action: string, callback: (event: T) => void) => void;
      off: <T = unknown>(action: string, callback?: (event: T) => void) => void;
    };
  }
}

const trackEvent = (event: string, action: string, params: GtagEventParams) => {
  if (typeof window !== 'undefined') {
    const gtag = window.gtag;
    if (gtag) {
      gtag(event, action, params);
    }
  }
};

export const trackLimitNotesPopup = () => {
  trackEvent('event', 'pop_up_view', {
    event_category: 'workspace',
    event_label: 'upgrade_options',
    item_name: 'notes_limit',
  });
};

export const trackLimitBlocksPopup = () => {
  trackEvent('event', 'pop_up_view', {
    event_category: 'workspace',
    event_label: 'upgrade_options',
    item_name: 'blocks_limit',
  });
};

export const trackPageWidgetPageCreate = (actionType: PageWidgetActionType) => {
  trackEvent('event', `page_create_${actionType}`, {
    event_category: 'dashboard',
    event_label: 'page_widget',
  });
};

export const trackInfoWidgetButtonClick = () => {
  trackEvent('event', 'button_click', {
    event_category: 'dashboard',
    event_label: 'info_widget',
  });
};

export const trackPortalWidgetPortalClick = () => {
  trackEvent('event', 'portal_click', {
    event_category: 'dashboard',
    event_label: 'portal_widget',
  });
};

export const trackPortalWidgetPortalInvite = () => {
  trackEvent('event', 'portal_invite', {
    event_category: 'dashboard',
    event_label: 'portal_widget',
  });
};

export const trackPortalWidgetPortalCreate = () => {
  trackEvent('event', 'portal_create', {
    event_category: 'dashboard',
    event_label: 'portal_widget',
  });
};

export const trackPortalWidgetPortalEditor = () => {
  trackEvent('event', 'portal_editor', {
    event_category: 'dashboard',
    event_label: 'portal_widget',
  });
};

export const trackPortalWidgetManageContent = () => {
  trackEvent('event', 'manage_content', {
    event_category: 'dashboard',
    event_label: 'portal_widget',
  });
};

export const trackDndErrorByChanges = (portalId: string, wsId: string, userId: number) => {
  const changesString = sessionStorage.getItem(PORTAL_CHANGES_HISTORY_STORAGE_KEY + portalId);
  let changes: ChangeEvent[] = [];
  try {
    if (changesString) {
      changes = JSON.parse(changesString);
    }
  } catch (err) {
    console.log('[Error parsing changes]', err);
  }
  const changeTypes: string[] = changes.reduce((acc, item) => {
    const type = item.type;
    if (!acc.includes(type)) {
      acc.push(type);
    }
    return acc;
  }, [] as string[]);
  const trackValue = changeTypes.reduce((acc, type, index) => {
    acc += type;
    if (index + 1 !== changeTypes.length) {
      acc += ',';
    }
    return acc;
  }, '');
  trackEvent('event', 'dnd_changes_error', {
    event_category: 'sidebar',
    event_label: `${wsId}_${portalId}_${userId}`,
    event_value: trackValue,
  });
};
